import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/measurements/edit/$systemName')({
  beforeLoad: () => getTitleContextSlice('Edit Measurement'),
});
